var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FileIcon from '@/shared/components/FileIcon';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
var TaskAttachmentsPopover = function (_a) {
    var attachments = _a.attachments, loadingAttachments = _a.loadingAttachments;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    return (_jsxs("span", __assign({ id: "popover-trigger-hover-focus" }, { children: [loadingAttachments ? _jsx("i", { className: "fa fa-spin fa-spinner" }) : null, attachments
                ? attachments.map(function (document) { return (_jsx("div", { children: _jsx("a", __assign({ onClick: function (e) {
                            setShowModalInfo({
                                modalType: ModalType.DocumentDetail,
                                documentId: document.id,
                            });
                            e.stopPropagation();
                        } }, { children: _jsxs("span", __assign({ className: "text-nowrap" }, { children: [_jsx(FileIcon, { document: document }), " ", document.name] })) })) }, document.id)); })
                : null] })));
};
export default TaskAttachmentsPopover;
